import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  categoryId: string;
  categoryName: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  categoryId,
  categoryName,
  publishDate,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-primary-200/60 transition-all duration-300">
      <Link to={`/category/${categoryId}`} className="inline-block mb-3">
        <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium whitespace-nowrap hover:bg-accent-200 transition-colors duration-200">
          <i className="ri-folder-line text-xs"></i>
          {categoryName}
        </span>
      </Link>

      <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
        <Link to={`/article/${slug}`} className="hover:underline decoration-primary-300 underline-offset-4">
          {title}
        </Link>
      </h3>

      <p className="text-sm text-foreground-500 mb-4 leading-relaxed line-clamp-2">
        {excerpt}
      </p>

      <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-400 mb-3">
        <span className="flex items-center gap-1">
          <i className="ri-calendar-line"></i>
          {publishDate}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-time-line"></i>
          {readTime}
        </span>
      </div>

      <div className="flex flex-wrap gap-1.5">
        {tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="inline-block px-2 py-0.5 bg-background-100 text-foreground-500 rounded text-xs whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>
    </article>
  );
}